import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { ScopeBar } from "@/components/scope-bar";
import { HelpButton } from "@/components/kb/help-button";

export const Route = createFileRoute("/_authenticated/app/receiving")({ component: ReceivingLayout });

function ReceivingLayout() {
  const loc = useLocation();
  const onIndex = loc.pathname === "/app/receiving";
  return (
    <div className="flex flex-col h-screen">
      <div className="border-b bg-card px-4 sm:px-6 py-4 sm:py-5">
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-3">
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl font-semibold tracking-tight">Receiving</h1>
            <p className="text-sm text-muted-foreground mt-1">
              {onIndex ? "Inbound shipments expected at the warehouse." : <Link to="/app/receiving" className="text-primary hover:underline">← Back to ASNs</Link>}
            </p>
          </div>
          {onIndex && (
            <div className="flex items-center gap-2 flex-wrap shrink-0 w-full xl:w-auto xl:justify-end">
              <ScopeBar />
              <HelpButton moduleKey="receiving" />
            </div>
          )}
        </div>
      </div>
      <div className="flex-1 overflow-auto"><Outlet /></div>
    </div>
  );
}